exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table.reportTbl[data-v-7c091e29]{border-collapse:collapse}.reportTbl th[data-v-7c091e29]{line-height:30px}.reportTbl th[data-v-7c091e29],.reportTbl tr td[data-v-7c091e29]{border:1px solid #ccc!important}.reportTbl tr.textCenter[data-v-7c091e29],.textCenter[data-v-7c091e29]{text-align:center}.reportTbl tr.textBold[data-v-7c091e29],.textBold[data-v-7c091e29]{font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7c091e29","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/project_info/project_forcust_report/dataForm.vue
// module id = 1212
// module chunks = 3